// extracted by mini-css-extract-plugin
export default {"FAQItem":"FAQItem_FAQItem","FAQQuestion":"FAQItem_FAQQuestion","FAQIcon":"FAQItem_FAQIcon"};